import React, { useState } from 'react';
import IntegrationDiscovery from '../../components/discovery/IntegrationDiscovery';
import IntegrationInstalled, { installedIntegrations } from '../../components/integrationInstalled/IntegrationInstalled';
import './Integrations.css';

const Integrations = () => {
  const [activeTab, setActiveTab] = useState('discover');

  // Get the count of installed integrations
  const installedIntegrationsCount = installedIntegrations.length;

  const renderTabContent = () => {
    switch (activeTab) {
      case 'installed':
        return <IntegrationInstalled />;
      case 'discover':
      default:
        return <IntegrationDiscovery />;
    }
  };

  return (
    <div className="integrations-page">
      <div className="main-title">Integrations</div>
      
      {/* Tabs */}
      <div className="tabs-container">
        <div 
          className={`tab ${activeTab === 'discover' ? 'active' : 'inactive'}`}
          onClick={() => setActiveTab('discover')}
        >
          Discover
        </div>
        <div 
          className={`tab ${activeTab === 'installed' ? 'active' : 'inactive'}`}
          onClick={() => setActiveTab('installed')}
        >
          Installed ({installedIntegrationsCount})
        </div>
      </div>
      
      {/* Search Bar */}
      <input
        type="text"
        placeholder="Search"
        className="search-input"
      />
      
      {/* Tab Content */}
      {renderTabContent()}
    </div>
  );
};

export default Integrations; 